import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Routes as ReactRouterRoutes } from 'react-router-dom';
/**
 * react-router-dom Routes ラップコンポーネント
 * @description https://reactrouter.com/en/main/components/routes
 */
export const CustomRoutes = (props) => {
    const { children, location } = props;
    return _jsx(ReactRouterRoutes, Object.assign({ location: location }, { children: children }));
};
